export default __webpack_public_path__ + "static/spitz-devices-c5138adf49cc5ae195ab2121b0126fca.jpg";